import CollapsedBlock from './component'

export default CollapsedBlock
